export const formattedDate = (dateValue?: string) => {
  const date = dateValue ? new Date(dateValue) : new Date()

  return date.toLocaleDateString('pt-BR')
}
